import styled from 'styled-components';

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	margin-left: auto;
	gap: ${({ theme }) => theme.spacing.xs};
`;

export const PageTitleWrapper = styled.div<{
	titleOrientation: 'horizontal' | 'vertical';
}>`
	display: flex;
	align-items: ${({ titleOrientation }) => {
		if (titleOrientation === 'horizontal') return 'center';
		return 'flex-start';
	}};
	flex-direction: ${({ titleOrientation }) => {
		if (titleOrientation === 'horizontal') return 'row';
		return 'column';
	}};
	height: 100%;
`;

export const PageTitle = styled.h1`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-family: ${({ theme }) => theme.fonts.family.default};
	font-size: ${({ theme }) => theme.fonts.sizes.medium};
	font-weight: ${({ theme }) => theme.fonts.weights.semiBold};
	line-height: ${({ theme }) => theme.fonts.lineHeight.large};
	letter-spacing: ${({ theme }) => theme.fonts.letterSpacing.large};
`;

export const PageSubTitle = styled.p<{
	titleOrientation: 'horizontal' | 'vertical';
}>`
	margin-left: ${({ titleOrientation, theme }) =>
		titleOrientation === 'horizontal' && theme.spacing.medium};
	margin-top: ${({ titleOrientation, theme }) =>
		titleOrientation === 'vertical' && theme.spacing.xxs};
	margin-bottom: 0 !important;
`;

export const PageHeaderContainer = styled.div<{
	size?: string;
	isVerticalWithSubtitle?: boolean;
}>`
	position: sticky;
	display: flex;
	align-items: center;
	top: 0;
	left: 0;
	width: 100%;
	padding: ${({ theme, size, isVerticalWithSubtitle }) => {
		switch (size) {
			case 'small':
				return `${theme.spacing.xs} ${theme.spacing.medium}`;

			case 'regular':
				return isVerticalWithSubtitle
					? `${theme.spacing.xxs} ${theme.spacing.large}`
					: `0 ${theme.spacing.large}`;
			default:
				return isVerticalWithSubtitle
					? `${theme.spacing.xxs} ${theme.spacing.large}`
					: `0 ${theme.spacing.large}`;
		}
	}};
	min-height: ${({ isVerticalWithSubtitle }) =>
		isVerticalWithSubtitle ? '60px' : '56px'};
	max-height: ${({ isVerticalWithSubtitle }) =>
		isVerticalWithSubtitle ? '60px' : '56px'};
	background-color: ${({ theme }) => theme.colors.system.background.white};
	z-index: ${({ theme }) => theme.zIndex.fixed};
	column-gap: 16px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.system.border.medium};
`;
